var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroupsCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 90,
    viewBox: "0 0 103 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.5166 26.7347C58.8296 26.7347 64.7579 20.9738 64.7579 13.8673C64.7579 6.7609 58.8296 1 51.5166 1C44.2037 1 38.2754 6.7609 38.2754 13.8673C38.2754 20.9738 44.2037 26.7347 51.5166 26.7347Z",
    stroke: "#A7ACC3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4795 75.2269C95.7925 75.2269 101.721 69.466 101.721 62.3595C101.721 55.2531 95.7925 49.4922 88.4795 49.4922C81.1666 49.4922 75.2383 55.2531 75.2383 62.3595C75.2383 69.466 81.1666 75.2269 88.4795 75.2269Z",
    stroke: "#A7ACC3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2413 75.2269C21.5542 75.2269 27.4825 69.466 27.4825 62.3595C27.4825 55.2531 21.5542 49.4922 14.2413 49.4922C6.92831 49.4922 1 55.2531 1 62.3595C1 69.466 6.92831 75.2269 14.2413 75.2269Z",
    stroke: "#A7ACC3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5273 15.793C71.8006 18.3028 78.1422 22.8565 82.7468 28.8757C87.3514 34.895 90.0113 42.1082 90.3888 49.5995",
    stroke: "#A7ACC3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6465 49.5457C13.0298 42.0756 15.6825 34.8833 20.2696 28.8773C24.8567 22.8713 31.1725 18.3209 38.4192 15.8008",
    stroke: "#A7ACC3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7989 73.806C79.1719 78.5654 74.4456 82.4308 69.0004 85.0908C63.5552 87.7509 57.5433 89.1313 51.4488 89.1209C45.3543 89.1105 39.3475 87.7096 33.912 85.0311C28.4764 82.3525 23.7641 78.471 20.1543 73.6992",
    stroke: "#A7ACC3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupsCard);
export default __webpack_public_path__ + "static/media/groupsCard.1465093b501c2cae21b5d8d311dd0ff8.svg";
export { ForwardRef as ReactComponent };